import {BadgeProps} from '@mui/material';

import {MatchPatternSet} from 'utils/hooks/useResolvedMatchParams';

export const enum IconKey {
  AI = 'ai',
  Home = 'home',
  Opportunities = 'opportunities',
  AccountManagers = 'accountManagers',
  AccountExecutives = 'accountExecutives',
  AccountSettings = 'accountSettings',
  Accounts = 'accounts',
  Activities = 'activities',
  Bookmark = 'bookmark',
  CarrierAppetite = 'carrierAppetite',
  Code = 'code',
  Copy = 'copy',
  CopyFilled = 'copy-filled',
  Favorite = 'favorite',
  FavoriteFilled = 'favorite-filled',
  Filters = 'filters',
  FiltersFilled = 'filters-filled',
  Producers = 'producers',
  Products = 'products',
  Markets = 'markets',
  Reports = 'reports',
  Industries = 'industries',
  Insights = 'insights',
  Prospects = 'prospects',
  Growth = 'growth',
  Retention = 'retention',
  RetailClients = 'retailClients',
  Renewals = 'renewals',
  Overview = 'overview',
  O360Score = 'o360score',
  Documents = 'documents',
  KPI = 'kpi',
  LossRuns = 'lossRuns',
  Settings = 'settings',
  Switch = 'switch',
  Storybook = 'storybook',
  LogOut = 'log-out',
  MonolineRatios = 'monoline-ratios',
  WhatsNew = 'whats-new',
}

export type SectionItemDivider = {
  divider: true;
};

type SectionItemBase = {
  id?: string;
  icon: IconKey;
  title: string;
  new?: boolean;
  badgeContent?: BadgeProps['content'];
};

export type SectionItemLink = SectionItemBase & {
  to: string;
  matchPattern?: MatchPatternSet[];
};

export type SectionItemButton = SectionItemBase & {
  onClick: () => void;
  disabled?: boolean;
  loading?: boolean;
};

export type SectionItem = SectionItemDivider | (SectionItemLink | SectionItemButton);

export type SidebarSection = {
  title?: string;
  items: SectionItem[];
};
